import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import { useTranslation } from "react-i18next";
import { formatImageName } from "../../utils/functions";
import "swiper/css";
import "swiper/css/navigation";

const FlashSalesOne = ({ shopBanners }) => {
  const { t } = useTranslation();

  return (
    <section className="pt-80">
      <div className="container">
        <div className="section-heading">
          <div className="flex-between flex-wrap gap-8">
            <h5 className="mb-0">{t("argetamSellersAds")}</h5>
            <div className="flex-align gap-16 mr-point"></div>
          </div>
        </div>
        <div className="flash-sales__slider arrow-style-two">
          <Swiper
            modules={[Navigation, Autoplay]}
            spaceBetween={20}
            slidesPerView={1}
            autoplay={{ delay: 3000 }}
            speed={1000}
            loop={false}
            // navigation={{
            //   nextEl: ".swiper-button-next",
            //   prevEl: ".swiper-button-prev",
            // }}
          >
            {shopBanners.map((banner, index) => (
              <SwiperSlide key={index}>
                <a
                  href={banner.link ? banner.link : `/shops/${banner.shopSlug}`}
                  target="_blank"
                  rel="noreferrer"
                  className="w-100"
                >
                  <img
                    src={formatImageName(banner.banner)}
                    className="VendorBanner w-100"
                    alt="Vendor Banner"
                  />
                </a>
              </SwiperSlide>
            ))}

            {/* Custom Navigation Buttons */}
            {/* <SampleNextArrow />
            <SamplePrevArrow /> */}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default FlashSalesOne;
